import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Log the error to your error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <div className="error-content">
                        <h1>Oops! Something went wrong</h1>
                        <p>We're sorry for the inconvenience. Please try one of the following:</p>
                        <ul>
                            <li>Refresh the page</li>
                            <li>Go back to the previous page</li>
                            <li>Return to the homepage</li>
                        </ul>
                        <div className="error-actions">
                            <button
                                onClick={() => window.location.reload()}
                                className="btn btn--primary"
                            >
                                Refresh Page
                            </button>
                            <Link to="/" className="btn btn--outline">
                                Go to Homepage
                            </Link>
                        </div>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="error-details">
                                <h3>Error Details:</h3>
                                <pre>{this.state.error.toString()}</pre>
                                <h3>Component Stack:</h3>
                                <pre>{this.state.errorInfo.componentStack}</pre>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

// HOC to wrap error boundary with navigation
export const withErrorBoundary = (WrappedComponent, options = {}) => {
    return (props) => (
        <ErrorBoundary {...options}>
            <WrappedComponent {...props} />
        </ErrorBoundary>
    );
};

export default ErrorBoundary;
